// Regression Coefficients are calculated https://docs.google.com/spreadsheets/d/1d2dYl_JoBgdICGurjc2MaJylAU41hlk2yjbx0wuhygY/edit#gid=1241204193 

const electricBFactor = {BMW: .233, Audi: .176, Nissan: .221, Ford: .198, Chevrolet: .197, Fiat: .4, Tesla: .123, Toyota: .114, Average: .201}
const gasBFactor = {BMW: .168, Audi: .174, Nissan: .18, Ford: .165, Chevrolet: .164, Fiat: .157, Toyota: .126, Average: .158}


const ageCalculator = modelYear => {
  return Math.max(0, new Date().getFullYear() - modelYear)
}

const msrpCalculator = (vehicle, fuel) => {
    const age = ageCalculator(vehicle.model_year)
    const bFactor = fuel === "gas" ? gasBFactor : electricBFactor
    let finalCoeff = bFactor[vehicle.make] ? bFactor[vehicle.make] : bFactor.Average
    let msrp = vehicle.msrp * Math.pow(Math.E, -1 * age * finalCoeff)
    msrp = Math.round(msrp / 1000) * 1000
    const lowerBoundMsrp = Math.round(msrp * .7 / 100) * 100
    const upperBoundMsrp = Math.round(msrp * 1.3 / 100) * 100
    return {
      msrp: msrp,
      lowerBoundMsrp:lowerBoundMsrp,
      upperBoundMsrp : upperBoundMsrp
    }
  }
  const rangeCalculator = (vehicle) => {
    // p: 188.898562907804 {inflection point of the curve (the age at which the rate of range degradation starts to decrease more rapidly) (constant)}
    // β: -0.177139574808916; {weight coefficient for the impact of battery capacity on the range score (constant)}
    // k:0.0187252612633212 {degradation rate, determines the steepness of the curve (constant)}
    // L: 102.3 (constant, upper limit of the predicted range score)

    const β = -0.177139574808916;
    const p = 188.898562907804;
    const k = 0.0187252612633212;
    const L = 102.3;

    const ageInMonths = ageCalculator(vehicle.model_year) * 12;
    const agedCapacity = vehicle.battery_capacity * β;
    const Degredation = -k * (ageInMonths + agedCapacity - p);
    return L - L / (1 + Math.E ** Degredation);
  }

const UsedVehicle = (vehicle) => {
    let electricMsrps = msrpCalculator(vehicle, "electric")
    let gasMsrps = msrpCalculator(vehicle.equivalent_gas_vehicle, "gas")
    vehicle.msrp = electricMsrps.msrp
    vehicle["lowerBoundMsrp"] = electricMsrps.lowerBoundMsrp
    vehicle["upperBoundMsrp"] = electricMsrps.upperBoundMsrp
    vehicle.equivalent_gas_vehicle.msrp = gasMsrps.msrp
    vehicle.equivalent_gas_vehicle["lowerBoundMsrp"] = gasMsrps.lowerBoundMsrp
    vehicle.equivalent_gas_vehicle["upperBoundMsrp"] = gasMsrps.upperBoundMsrp
    vehicle.electric_range = Math.round((vehicle.electric_range * rangeCalculator(vehicle)) / 100);
    return vehicle
};

export default UsedVehicle;
